function $element(name) {
	return document.querySelector(`[xyl-element*="${name}"]`);
}

function $elementChild(element, name) {
	return element.querySelector(`[xyl-element*="${name}"]`);
}

function $elements(name) {
	return document.querySelectorAll(`[xyl-element*="${name}"]`);
}

function $elementChildren(element, name) {
	return element.querySelectorAll(`[xyl-element*="${name}"]`);
}

function $tabModule($root) {
	return $root.querySelector(`[xyl-tab-module]`);
}

export { $element, $elements, $elementChild, $elementChildren, $tabModule };
